import { Component } from 'preact';
import style from './DesktopHeader.scss';
import { connect } from 'react-redux';
// import MutationDropdown from '../mutationDropdown/MutationDropdown';
import RouteHelper from '../../../helpers/RouteHelper';
import { Link } from 'react-router-dom';
import '../Header.scss';
import Logo from '../../logo';
import {FOOTSHOP_LOGO_COLORS} from '../../logo/constants';

// eslint-disable-next-line react/prefer-stateless-function
class DesktopHeader extends Component {
	render({ location, mutation, currency, mutations, dark, children, route, suggestedShopId }) {
		const { pathname } = location;
		return (
			<header className={`${style.header} desktop ${style.light}`}>
				<div className={style['top-bar']}>
					<Link to={RouteHelper.getUrl('/shipping')}><img src="/assets/images/icons/icon-shipping.png" />Shipping</Link>
					<a href={RouteHelper.getExternalUrl('/phone')}><img src="/assets/images/icons/icon-phone.png" />+44 2038071459</a>
					<a href={RouteHelper.getExternalUrl('/faq')}><img src="/assets/images/icons/icon-faq.png" />FAQ</a>
					<a href={RouteHelper.getExternalUrl('/about')}><img src="/assets/images/icons/icon-lightbulb.png" />About us</a>

					{/*{ mutations.loaded ? <MutationDropdown {...{ pathname, mutation, currency, mutations, right: true, disabled: ( mutations.items.length < 2) }} /> : null }*/}
				</div>
				<nav className={`navbar ${route.modifyHeader ? style['no-background'] : ''}`}>
					<Link to={RouteHelper.getUrl('/')}>
						<Logo color={FOOTSHOP_LOGO_COLORS.WHITE}/>
					</Link>
					{!route.modifyHeader && (
						<a className={`go-to-shop ${style['go-to-shop-desktop']}`} href={RouteHelper.getExternalUrlByShopId(suggestedShopId)}>
							Go to eshop <span className={'arrow'}/>
						</a>
					)}
				</nav>
				<div className={style.separator} />
			</header>
		);
	}
}

const mapStateToProps = (state) => {
	const { ui } = state;
	return {
		mutations: state.mutations,
		mutation: ui.mutation,
		currency: ui.currency,
		suggestedShopId: ui.suggestedShopId,
	};
};

export default connect(mapStateToProps)(DesktopHeader);



// WEBPACK FOOTER //
// ./components/header/desktop/DesktopHeader.js